var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2770_15284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#777777"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2770_15284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80768 20C4.57884 20 4.38702 19.9226 4.2322 19.7678C4.0774 19.613 4 19.4212 4 19.1923V13.5C4 13.3583 4.04798 13.2396 4.14395 13.1438C4.2399 13.0479 4.35881 13 4.50067 13C4.64252 13 4.76121 13.0479 4.85672 13.1438C4.95224 13.2396 5 13.3583 5 13.5V18.3115L18.3115 5H13.5C13.3583 5 13.2396 4.95202 13.1438 4.85605C13.0479 4.76008 13 4.64118 13 4.49933C13 4.35746 13.0479 4.23878 13.1438 4.14328C13.2396 4.04776 13.3583 4 13.5 4H19.1923C19.4212 4 19.613 4.0774 19.7678 4.2322C19.9226 4.38702 20 4.57884 20 4.80768V10.5C20 10.6417 19.952 10.7604 19.8561 10.8563C19.7601 10.9521 19.6412 11 19.4993 11C19.3575 11 19.2388 10.9521 19.1433 10.8563C19.0478 10.7604 19 10.6417 19 10.5V5.68848L5.68848 19H10.5C10.6417 19 10.7604 19.048 10.8563 19.144C10.9521 19.2399 11 19.3588 11 19.5007C11 19.6425 10.9521 19.7612 10.8563 19.8567C10.7604 19.9522 10.6417 20 10.5 20H4.80768Z",
    fill: "#777777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatOpen);
export default __webpack_public_path__ + "static/media/Icon_chat_open.b26730048b4b6f2e1d9894de441b935b.svg";
export { ForwardRef as ReactComponent };